// extracted by mini-css-extract-plugin
export default {"menuBlock":"DE-z","title":"EE-z","nav":"FE-z","flexCell":"GE-z","facetLink":"HE-z"};